<div class="m-4">
  <h2 class="mb-4">{{title}}</h2>
  <p class="mb-5">{{description}}</p>
  <table class="mt-2">
    <tr *ngFor="let item of infoList">
      <td class="fw-bold pe-3">{{item.label}}:</td>
      <td>{{item.value}}</td>
    </tr>
  </table>
  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" [disabled]="buttonsDisabled" i18n="@@confirm-modal.cancel">{{ cancelButton || 'Avbryt' }}</button>
    <button class="btn btn-primary btn-min-width" id="confirmBtn" type="button" (click)="activeModal.close()" [disabled]="buttonsDisabled" i18n="@@confirm-modal.confirm">{{ confirmButton || 'Bekräfta' }}</button>
  </div>
</div>
